exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.commentary div.highlights div.key-wrap {\n  border-radius: 2rem;\n  border: 0.2rem solid #052738;\n}\ndiv.commentary div.highlights div.key-wrap h1 {\n  font-size: 2rem;\n}", ""]);

// exports
